var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarLinear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h24v24H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.873 7.534l-6.008-.874-2.685-5.43c-.48-.967-1.875-.98-2.36 0L7.135 6.66l-6.008.874C.049 7.69-.383 9.014.399 9.773l4.346 4.224-1.028 5.967c-.185 1.079.954 1.887 1.908 1.382L11 18.53l5.375 2.817c.954.5 2.093-.303 1.908-1.382l-1.028-5.967L21.6 9.773c.781-.759.35-2.083-.728-2.24zm-5.736 5.774l.974 5.676L11 16.306l-5.111 2.678.974-5.676L2.726 9.29l5.716-.828L11 3.293l2.558 5.168 5.716.828-4.137 4.02z",
    fill: "#151A30"
  }))));
}

export default SvgStarLinear;